import { render, staticRenderFns } from "./PrintersModal.vue?vue&type=template&id=8146eb60&"
import script from "./PrintersModal.vue?vue&type=script&lang=js&"
export * from "./PrintersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports